export default function FaqData() {
    return [
        {
            title: "Will my whole life insurance premium payments ever go up?",
            text: ["No. With a whole life policy, your premiums are guaranteed not to go up as long as premiums are paid according to policy specifications."]
        },
        {
            title: "Can the company cancel my coverage if I get sick after my policy is issued?",
            text: ["No. Whole life insurance coverage cannot be canceled if the insured gets sick after the policy is bound by the insurance carrier, as long as premiums are paid according to policy specifications."]
        },
        {
            title: "How much coverage should I purchase?",
            text: ["The amount of coverage needed for each person is unique to his or her personal and financial situation. Life insurance has a variety of uses which should be considered, including as protection for family in the case of an untimely death and providing a tax-advantaged inheritance. Here are some additional things to keep in mind as you make your decision:",
                [
                    "How many children do you have and how old are they?",
                    "Who primarily cares for your children? Would that change after your death?",
                    "Do you already have college funds and retirement savings?",
                    "Does your spouse work? Would that change after your death?",
                    "What will it cost to pay off your home mortgage and other debt?",
                    "What will it cost for your family to maintain their lifestyle?",
                    "How much would you want to leave your family as an inheritance?"
                ],
                "We are happy to assist you in evaluating how much coverage is the right amount. Contact us by phone, email, or chat."
            ]
        }
    ]
}